import { Component, OnInit } from '@angular/core';
import { PagingContainerModel } from 'src/app/model/paging-container.model';
import { ProcessSummaryModel } from 'src/app/model/process-summary.model';
import { PagingModel } from 'src/app/model/paging.model';

import swal from 'sweetalert2';
import { SearchParamsModel } from 'src/app/model/search-params.model';
import { environment } from 'src/environments/environment';
import { ExportService } from 'src/app/service/export.services';
import { WorkflowGatewayService } from 'src/app/service/workflow-gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/service/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BackdropService } from 'src/app/service/backdrop.service';
import { AttributeModel } from '../../dynamic/model/attribute.model';
import { DesignService } from 'src/app/service/design.service';
import { DataTablesModule } from 'angular-datatables/src/angular-datatables.module';
import { Config } from 'protractor';
import { CurrencyService } from "../../../service/currency.service";
import { MaskApplierService } from "ngx-mask";
import { ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ProrrogacaoComponent } from 'src/app/components/stik/prorrogacao/prorrogacao.component';
import { BaixaComponent } from 'src/app/components/stik/baixa/baixa.component';
import { AbatimentoComponent } from 'src/app/components/stik/abatimento/abatimento.component';
import { HistoryComponent } from 'src/app/components/stik/history/history.component';

@Component({
  selector: "app-process-grid",
  templateUrl: "./process-grid.component.html",
  styleUrls: ["./process-grid.component.scss"],
})
export class ProcessGridComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;

  Config = DataTablesModule;

  dtOptions: Config = {};
  
  pagingModel: PagingModel;
  processes: ProcessSummaryModel[];
  countPage: number = 1;
  currentPage: number = 1;
  totalPages: number = 0;
  totalColumns: number[];
  searchParams: SearchParamsModel = new SearchParamsModel();
  listExcel: any[];
  itemExcel: any;
  showModalPrint: boolean;
  printProcessId: string;
  itemsAttr: AttributeModel[];
  selectedPrintItems: string[];
  sourceUrl: string;
  dtTrigger: Subject<any> = new Subject<any>();

  isModalOpen: boolean = false;
  modalTitle: string = '';
  modalData: any = null;

  constructor(
    private exportService: ExportService,
    private workflowService: WorkflowGatewayService,
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private backdrop: BackdropService,
    private designService: DesignService,
    private maskService: MaskApplierService,
    private currencyService: CurrencyService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {

    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      responsive: true,
      lengthMenu: [
      [5, 10, 25, 50, -1],
      ["5", "10", "25", "50", "Todas"],
      ],
      language: {
      url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json",
      },
      ordering: true,
      autoWidth: false,
      columnDefs: [
        { orderable: false, targets: -1 }
      ],
      bSort: true,
      dom: 'Bfrtip',
      buttons: [
      {
        extend: 'excel',
        text: '<i class="fa fa-file-excel-o"></i> Excel',
        className: 'btn btn-outline-success mr-1',
        exportOptions: {
        columns: ':visible'
        },
        title: `Boletos_${this.getCurrentDate()}` // Add date in ddmmyyyy format
      },
      {
        extend: 'csv',
        text: '<i class="fa fa-file-text-o"></i> CSV',
        className: 'btn btn-outline-primary mr-1',
        exportOptions: {
        columns: ':visible'
        },
        title: `Boletos_${this.getCurrentDate()}` // Add date in ddmmyyyy format
      },
      {
        extend: 'pdf',
        text: '<i class="fa fa-file-pdf-o"></i> PDF',
        className: 'btn btn-outline-danger',
        exportOptions: {
        columns: ':visible'
        },
        title: `Boletos_${this.getCurrentDate()}`, // Add date in ddmmyyyy format
        orientation: 'landscape'
      }
      ]
    };

    this.setSearchParams();
    this.totalColumns = [];

    // setTimeout(() => window.scrollTo(0, 0), 500);

  }

  private setSearchParams() {
    this.route.params.subscribe(params => {
      this.searchParams.policyId = params.policyId ?? null;
      this.searchParams.policyTypeId = params.typeId ?? null;

      const key = this.getSearchParamsKey();

      if (!sessionStorage.getItem(key)) {
        const initialSearchParams: SearchParamsModel = {
          policyId: this.searchParams.policyId,
          policyTypeId: this.searchParams.policyTypeId,
          attributes: [],
          nome: '',
          orderDesc: false,
        };
        sessionStorage.setItem(key, JSON.stringify(initialSearchParams));
      }

      this.searchParams = JSON.parse(sessionStorage.getItem(key) || '{}');
      this.loadProcesses();
    });
  }

  getItemValue(process: ProcessSummaryModel, index: number): string {
    const item = process.attributes?.[index];
  
    if (item?.value) {
      const maskOpt = item.options?.find(opt => opt.key.toLowerCase() === "mask");
  
      if (maskOpt) {
        switch (maskOpt.value?.toLowerCase()) {
          case "separator.2":
          case "currency":
            return this.currencyService.formatCurrencyValue(item.value);
          case "document":
            const docMask = this.getDocumentMask(item);
            return this.maskService.applyMask(item.value, docMask);
          case "date":
          case "date br":
            return this.formatDateToBR(new Date(item.value));
          case "datetime":
          case "datetime br":
            return this.formatDateTimeToBR(new Date(item.value));
        }
      }
  
      return item.value;
    }
  
    return '';
  }  

  protected getDocumentMask(attribute: AttributeModel): string {
      if(attribute.value && attribute.value.length > 11) {
          return "00.000.000/0000-00"
      } else {
          return "000.000.000-00**"
      }
  }

  protected formatDateToBR(date: Date): string {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
    
      return `${day}/${month}/${year}`;
  }

  protected formatDateTimeToBR(dateTime: Date): string {
      const day = dateTime.getDate().toString().padStart(2, '0');
      const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
      const year = dateTime.getFullYear();
      const hours = dateTime.getHours().toString().padStart(2, '0');
      const minutes = dateTime.getMinutes().toString().padStart(2, '0');
      const seconds = dateTime.getSeconds().toString().padStart(2, '0');
    
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  private getItemBy(index: number): AttributeModel {
    return this.processes[index].attributes[index]
  }

  private getSearchParamsKey(): string {
    const id = this.getPolicyOrTypeId();
    const prefix = this.searchParams.policyId ? 'policy' : 'type';
    return `searchParams_${prefix}_${id}`;
  }

  private getPolicyOrTypeId(): string {
    const value = this.searchParams.policyId ? `policy/${this.searchParams.policyId}` : `type/${this.searchParams.policyTypeId}`;
    const match = value.match(/(policy|type)\/(.+)/);
    return match ? match[2] : '';
  }

  doSearch() {
    localStorage.removeItem("pageNumber");
    this.loadProcesses();
  }

  private getCurrentDate(): string {
    const date = new Date();
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}${month}${year}`;
  }

  getColumnTitle(index: number): string {
    if(!this.processes || this.processes.length == 0) {
      return this.getDefaultTitle(index);
    }

    let firstItemAttrs = this.processes[0].attributes;

    if(!firstItemAttrs[index] || !firstItemAttrs[index].options) {
      return this.getDefaultTitle(index);
    }

    let titleOpt = firstItemAttrs[index].options
      .find(opt => opt.key.toLowerCase() == "title");

    return titleOpt ? titleOpt.value : firstItemAttrs[index].key;
  }

  private getDefaultTitle(index: number): string {
    if(index == 0) {
      return "Nome";
    } else if(index == 1) {
      return "Tipo";
    }

    return "Nome";
  }

  calculateTotalColumns() {
    if (this.processes && this.processes.length > 0) {
      const attributeCount = this.processes[0].attributes.length;
      this.totalColumns = Array.from({ length: attributeCount }, (_, i) => i);
    } else {
      this.totalColumns = [];
    }
  }

  loadProcesses(pagina?: number, showLoading: boolean = true) {
    if (showLoading) {
      this.spinner.show();
    }

    if (!pagina && localStorage.getItem("pageNumber")) {
      pagina = +localStorage.getItem("pageNumber");
    }

    const key = this.getSearchParamsKey();
    if (sessionStorage.getItem(key)) {
      this.searchParams = JSON.parse(sessionStorage.getItem(key));
    }

    this.searchParams.orderDesc = false;

    const menuConfig = this.designService.getCurrentMenuConfig();
    if (menuConfig && menuConfig.attributes) {
      const sourceUrlAttribute = menuConfig.attributes.find(attr => attr.key.toLowerCase() === 'source url');
      this.sourceUrl = sourceUrlAttribute ? sourceUrlAttribute.value : null;
    } else {
      this.sourceUrl = null;
    }

    this.workflowService
      .getSummary(pagina, environment.processPageSize, {
        searchParams: this.searchParams,        
      },
      this.sourceUrl   
      )
      .subscribe(
        (pagingContainer: PagingContainerModel) => {
          if (pagingContainer.items.length == 0 && pagina > 1) {
            this.mudarPagina(1, false);
          } else {
            this.processes = pagingContainer.items;

            if (this.dtElement?.dtInstance) {
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
            
                this.processes = pagingContainer.items;
                this.pagingModel = pagingContainer.paging;
                this.calculateTotalColumns();
            
                setTimeout(() => {
                  this.dtTrigger.next(null);
                }, 0);
              });
            } else {
              this.processes = pagingContainer.items;
              this.pagingModel = pagingContainer.paging;
              this.calculateTotalColumns();
            
              setTimeout(() => {
                this.dtTrigger.next(null);
              }, 0);
            }

            this.pagingModel = pagingContainer.paging;
            this.calculateTotalColumns();
            this.spinner.hide();

            this.workflowService
              .getCount(environment.processPageSize, { searchParams: this.searchParams }, this.sourceUrl)
              .subscribe(
                (countResult) => {
                  this.totalPages = countResult.totalPages;
                },
                () => {}
              );
          }
        },
        (error) => this.handleHttpError(error)
      );
  }

  mudarPagina(pageNumber: number, showLoading: boolean = true) {
    if (!pageNumber) {
      pageNumber = 1;
    }

    localStorage.setItem("pageNumber", pageNumber.toString());
    this.loadProcesses(pageNumber, showLoading);
  }

  lastPages() {
    if (this.totalPages > 0 && this.currentPage <= this.totalPages) {
      this.currentPage = this.totalPages - 14;
      this.countPage = this.currentPage;
      localStorage.setItem("pageNumber", this.currentPage.toString());
      this.loadProcesses(this.currentPage, true);
    }
  }

  firstPages() {
    this.currentPage = 1;
    this.countPage = this.currentPage;
    localStorage.setItem("pageNumber", this.currentPage.toString());
    this.loadProcesses(this.currentPage, true);
  }

  nextPages(currentPage: number) {
    if (this.totalPages > 0 && this.currentPage <= this.totalPages) {
      this.currentPage = currentPage + 15;
      this.countPage = this.currentPage;
      localStorage.setItem("pageNumber", this.currentPage.toString());
      this.loadProcesses(this.currentPage, true);
    }
  }

  previousPages(currentPage: number) {
    if (this.currentPage >= 15) {
      this.currentPage = currentPage - 15;
      this.countPage = this.currentPage;
      localStorage.setItem("pageNumber", this.currentPage.toString());
      this.loadProcesses(this.currentPage, true);
    }
  }

  obterPaginas(): number[] {
    let pageNumbers: number[] = [];
    if (this.pagingModel && this.totalPages > 0) {
      for (let index = this.countPage; index <= this.countPage + 14; index++) {
        if (index <= this.totalPages && index >= 1) {
          pageNumbers.push(index);
        }
      }
    }
    return pageNumbers;
  }

  isActive(numero: number) {
    return this.pagingModel ? numero == this.pagingModel.pageNumber : false;
  }

  onValueChange(value: any) {
    if (value.target.checked) {
      this.selectedPrintItems.push(value.target.value);
    } else {
      const indexRemove = this.selectedPrintItems.indexOf(value.target.value);
      this.selectedPrintItems.splice(indexRemove, 1);
    }
  }

  updateList() {
    this.loadProcesses();
  }

  private handleHttpError(error: any) {
    this.spinner.hide();

    if (error.status == 401) {
      this.authService.logout();
      this.router.navigate(['login']);
    } else if (error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()));
    } else if (error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if (error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close());
        }
      });
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error");
    }
  }

  getActionOption(action: any, key: string): string | null {
    const option = action.options?.find(opt => opt.key === key);
    return option ? option.value : null;
  }

  isLinkAction(action: any): boolean {
    return this.getActionOption(action, 'type') === 'link';
  }

  isModalAction(action: any): boolean {
    return this.getActionOption(action, 'type') === 'modal';
  }

  isHistoryAction(action: any): boolean {
    return action['key'] === 'History';
  }

  openCustomModal(action: any, process: ProcessSummaryModel): void {
    const modalPath = this.getActionOption(action, 'modalPath');
    if (modalPath === 'Stik/Prorrogacao') {
      this.isModalOpen = true;
      this.modalTitle = 'Prorrogação';
      this.modalData = process.attributes;
    }
    if (modalPath === 'Stik/Abatimento') {
      this.isModalOpen = true;
      this.modalTitle = 'Abatimento';
      this.modalData = process.attributes;
    }
    if (modalPath === 'Stik/Baixa') {
      this.isModalOpen = true;
      this.modalTitle = 'Baixa';
      this.modalData = process.attributes;
    }
    if (action['key'] === 'History') {
      this.isModalOpen = true;
      this.modalTitle = 'Histórico';
      this.modalData = process.attributes;
    }
  }

  closeModal(): void {
    this.isModalOpen = false;
    this.modalTitle = '';
    this.modalData = null;
  }

  getVisibleAttributes(process: ProcessSummaryModel): AttributeModel[] {
    return process.attributes?.filter(attr => {
      const viewModeOption = attr.options?.find(opt => opt.key === 'ViewMode');
      return viewModeOption?.value !== 'hidden';
    }) || [];
  }

  getVisibleColumns(): number[] {
    if (!this.processes || this.processes.length === 0) {
      return [];
    }
  
    const firstProcess = this.processes[0];
    return firstProcess.attributes
      ?.map((attr, index) => {
        const viewModeOption = attr.options?.find(opt => opt.key === 'ViewMode');
        return viewModeOption?.value !== 'hidden' ? index : null;
      })
      .filter(index => index !== null) as number[];
  }

  getStatus(process: ProcessSummaryModel): string {
    const statusOption = process.attributes?.find(attr => attr.key === 'Status');
    return statusOption ? statusOption.value : '';
  }
}
